module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-resumido-comitente sys-table",
    class: {
      'bg-danger': _vm.comConnected === 2
    }
  }, [_c('div', {
    staticClass: "chat-content"
  }, [_c('div', {
    staticClass: "message0 no-select"
  }, [_vm._v("\n      Nenhuma mensagem\n    ")]), _vm._v(" "), (_vm.comConnected === 2) ? _c('div', {
    staticClass: "message0 no-select"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Comunicação RealTime com problemas. Tentando reconectar")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-440a2032","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/pregao/components/ChatResumidoComitente.vue
// module id = 1630
// module chunks = 17